import { Link } from "react-router-dom";

const HeadstoneIcon = ({ size = 14, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
    <path
      d="M16 3 C 10 3, 6 7, 6 14 L 6 28 L 26 28 L 26 14 C 26 7, 22 3, 16 3 Z"
      stroke="currentColor"
      strokeWidth="1.8"
      fill="none"
    />
    <line x1="16" y1="10" x2="16" y2="20" stroke="currentColor" strokeWidth="1.4" />
    <line x1="11" y1="14" x2="21" y2="14" stroke="currentColor" strokeWidth="1.4" />
  </svg>
);

const LambIcon = ({ size = 28, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className} aria-hidden>
    {/* body — cloud-like fleece */}
    <path
      d="M14 38 C 10 34, 12 26, 20 26 C 22 20, 32 20, 34 26 C 40 24, 48 28, 46 34 C 50 36, 48 44, 42 44 L 18 44 C 12 44, 10 40, 14 38 Z"
      fill="#EBE8E0"
      stroke="#3F5746"
      strokeWidth="1.5"
    />
    {/* head */}
    <ellipse cx="42" cy="30" rx="6" ry="7" fill="#3F5746" />
    {/* ear */}
    <path d="M44 24 C 46 22, 49 23, 48 26" stroke="#3F5746" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    {/* eye */}
    <circle cx="44" cy="30" r="0.9" fill="#F7F6F2" />
    {/* legs */}
    <line x1="20" y1="44" x2="20" y2="52" stroke="#3F5746" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="28" y1="44" x2="28" y2="52" stroke="#3F5746" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="36" y1="44" x2="36" y2="52" stroke="#3F5746" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="42" y1="44" x2="42" y2="52" stroke="#3F5746" strokeWidth="1.8" strokeLinecap="round" />
    {/* ground tuft */}
    <path d="M14 54 L 18 51 L 22 54 L 26 51 L 30 54 L 34 51 L 38 54 L 42 51 L 46 54"
          stroke="#3F5746" strokeWidth="1" fill="none" strokeLinecap="round" />
  </svg>
);

export default function Navbar({ businessName = "Heritage Stone Care" }) {
  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-[#F7F6F2]/85 border-b border-[#DCD9CE]/60"
      data-testid="navbar"
    >
      <div className="container-x flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-home-link">
          <LambIcon size={32} />
          <span className="font-serif-heading text-xl tracking-tight">{businessName}</span>
        </Link>
        <div className="hidden md:flex items-center gap-10 text-sm">
          <a href="#mission" className="text-[#5C5C5C] hover:text-[#232323] transition" data-testid="nav-mission">
            Mission
          </a>
          <a href="#gallery" className="text-[#5C5C5C] hover:text-[#232323] transition" data-testid="nav-gallery">
            Our Work
          </a>
          <a href="#process" className="text-[#5C5C5C] hover:text-[#232323] transition" data-testid="nav-process">
            Process
          </a>
          <a href="#estimate" className="text-[#5C5C5C] hover:text-[#232323] transition" data-testid="nav-estimate">
            Estimate
          </a>
        </div>
        <a href="#quote" className="btn-primary text-xs" data-testid="nav-cta-quote">
          <HeadstoneIcon size={14} />
          Request Quote
        </a>
      </div>
    </nav>
  );
}
